function cov_j7np12nqz() {
  var path = "/app/src/utils/check-locale.tsx";
  var hash = "ead9455b0bc2dde21669f3e9809f2d8ca76e8158";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/check-locale.tsx",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 27
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 20,
          column: 3
        }
      },
      "2": {
        start: {
          line: 11,
          column: 4
        },
        end: {
          line: 13,
          column: 46
        }
      },
      "3": {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      "4": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 43
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 27
          },
          end: {
            line: 6,
            column: 28
          }
        },
        loc: {
          start: {
            line: 9,
            column: 5
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 9
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 11,
            column: 11
          },
          end: {
            line: 13,
            column: 45
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 12,
            column: 8
          },
          end: {
            line: 12,
            column: 43
          }
        }, {
          start: {
            line: 13,
            column: 8
          },
          end: {
            line: 13,
            column: 45
          }
        }],
        line: 11
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ead9455b0bc2dde21669f3e9809f2d8ca76e8158"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_j7np12nqz = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_j7np12nqz();
import { dictionaryMapLanguage } from 'src/constants/dictionary-map-language';
import { getLangCode } from 'src/utils/get-lang-code';
import { getLocale } from 'src/utils/get-locale';
cov_j7np12nqz().s[0]++;
export var checkLocale = function checkLocale(value, _ref) {
  var lang = _ref.lang;
  cov_j7np12nqz().f[0]++;
  cov_j7np12nqz().s[1]++;
  try {
    cov_j7np12nqz().s[2]++;
    return lang ? (cov_j7np12nqz().b[0][0]++, getLocale(getLangCode(lang), value)) : (cov_j7np12nqz().b[0][1]++, getLocale(getLangCode(value)));
  } catch (_unused) {
    cov_j7np12nqz().s[3]++;
    // eslint-disable-next-line no-console
    console.warn('The locale parameter has an incorrect value. Please check it');
    cov_j7np12nqz().s[4]++;
    return dictionaryMapLanguage.en.locale;
  }
};